import { extendTheme, Theme } from "@chakra-ui/react";
import { Styles } from "@chakra-ui/theme-tools";
import * as components from "./components";
import * as foundations from "./foundations";

export interface AreaHubTheme
  extends Omit<Theme, "colors" | "components" | "shadows"> {
  colors: Theme["colors"] & typeof foundations.colors;
  components: Theme["components"] & typeof components;
  shadows: typeof foundations.shadows;

  styles: Styles & typeof foundations.styles;

  fonts: Theme["fonts"] & typeof foundations.fonts;
  semanticTokens: typeof foundations.semanticTokens & Theme["semanticTokens"];
}

export const theme = extendTheme({
  ...foundations,

  components: {
    ...components,
  },
});
